import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { currencyFormatter } from "../../utils/Utils";

// ItemPrice: displays unit price and total value (excludes stock display)
// Props: { price, totalValue, showPricing }
export const ItemPrice = React.memo(function ItemPrice({
  price,
  totalValue,
  showPricing = true,
}) {
  if (!showPricing) return null;
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        alignItems: "center",
        fontVariantNumeric: "tabular-nums",
      }}
    >
      <Typography sx={{ minWidth: 72, textAlign: "right" }}>
        {currencyFormatter("GB", price)}
      </Typography>
      <Typography sx={{ minWidth: 72, textAlign: "right", fontWeight: "bold" }}>
        {currencyFormatter("GB", totalValue)}
      </Typography>
    </Stack>
  );
});

export default ItemPrice;
